import { Box, Grid, Link, Typography } from "@mui/material";
import { connect } from "react-redux";
import React from "react";
import FlecheSVG from "../../ressources/images/FlecheSVG";
import MonBienSVG from "../../ressources/images/MonBienSVG";
import PiecesSVG from "../../ressources/images/PiecesSVG";
import SituationPersoSVG from "../../ressources/images/SituationPersoSVG";
import SituationProSVG from "../../ressources/images/SituationProSVG";
import SyntheseSVG from "../../ressources/images/SyntheseSVG";
import Libelle from "../../_i18n/fr.json";
import styles from "./styles";
import { Selectors as DossierLocationSelectors } from "../../redux/DossierLocation";
import { Selectors as PartenaireSelectors } from "../../redux/Partenaire";
import Grid2 from "@mui/material/Unstable_Grid2";
import { ArrowLeft } from "@mui/icons-material";
import { useSelector } from "react-redux";
import Types from "Types";

interface Props {
  // Etape en cours en visualisation
  isEtape?:
    | "monBien"
    | "situationPersonnelle"
    | "situationProfessionnelle"
    | "justificatifs"
    | "synthese";
  // Permet de faire varier le styles
  variant?: "dossierLocation";
  // Si l'étape pièces justificatives doit être affichée ou non
  isControleDossier?: boolean;
  fetching?: boolean;
}

/**
 * Composant affichant un message d'erreur sous forme de snack.
 */
function CheminDeFer({ isEtape, variant }: Props) {
  const isControleDossier = useSelector((state: Types.RootState) =>
    PartenaireSelectors.getControleDossier(state)
  );

  const fetching = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getDossierSyntheseFetching(state)
  );
  //   || PartenaireSelectors.getPartenaireFetching(state),

  let mapDossierLocation = [
    {
      name: "monBien",
      img: <MonBienSVG />,
      libelle: Libelle.cheminDeFer.bien,
      description: "",
    },
    {
      name: "situationPersonnelle",
      img: <SituationPersoSVG />,
      libelle: Libelle.cheminDeFer.situationPersonnelle,
      description: undefined,
    },
    {
      name: "situationProfessionnelle",
      img: <SituationProSVG />,
      libelle: Libelle.cheminDeFer.situationProfessionnelle,
      description: undefined,
    },
  ];
  const justif = {
    name: "justificatifs",
    img: <PiecesSVG />,
    libelle: Libelle.cheminDeFer.justificatifs,
    description: undefined,
  };
  const synthese = {
    name: "synthese",
    img: <SyntheseSVG />,
    libelle: Libelle.cheminDeFer.synthese,
    description: undefined,
  };
  if (isControleDossier) {
    mapDossierLocation.push(justif);
  }
  mapDossierLocation.push(synthese);
  // const maMap = mapDossierLocation;
  // return maMap;

  // const maMap = this.renderMap();

  return (
    <Box className={"container"} sx={styles}>
      <Grid2
        container
        justifyContent="space-between"
        className={"containerLink"}
      >
        <Link href="/dashboard" color="inherit" className="backLink">
          <ArrowLeft /> Retour au dashboard
        </Link>
      </Grid2>

      {!fetching && (
        <Grid2
          container
          component="ul"
          justifyContent="center"
          className={"root"}
        >
          {mapDossierLocation.map((etape, index) => {
            let classNameItem = "item " + variant;
            if (isEtape === etape.name) classNameItem += " etapeEnCours";
            return (
              <React.Fragment key={index}>
                <Grid item component="li" className={classNameItem}>
                  {etape.img}
                  <Typography component="span">{etape.libelle}</Typography>
                  {etape.description && (
                    <div className={"etapeDescription"}>
                      {etape.description}
                    </div>
                  )}
                </Grid>
                {mapDossierLocation.length !== index + 1 && (
                  <Grid item component="li" className={"fleche"}>
                    <FlecheSVG />
                  </Grid>
                )}
              </React.Fragment>
            );
          })}
        </Grid2>
      )}
    </Box>
  );
}

export default CheminDeFer;
